// extracted by mini-css-extract-plugin
module.exports = {"file":"styles_file__Wn8Kr","uploading":"styles_uploading__cx3iV","successUploading":"styles_successUploading__Wg3zy"};